import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M1 19h22V5H1v14zM19 7v10H5V7h14z"
}), 'StayCurrentLandscapeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StayCurrentLandscapeSharp.js
// module id = 6486
// module chunks = 2